const faqData = [
    {
      id: 1,
      question: "What technologies do you specialize in?",
      answer: "I specialize in front-end technologies like HTML, CSS, and JavaScript, as well as the MERN stack, which includes MongoDB, Express, React, and Node.js."
    },
    {
      id: 2,
      question: "Do you have experience with back-end development?",
      answer: "Yes, I have experience working with back-end technologies like Node.js and Express.js. I've also used databases such as MongoDB in various projects."
    },
    {
      id: 3,
      question: "Can you describe your design process?",
      answer: "My design process involves understanding client requirements, wireframing, creating mockups, and iterating based on feedback. I focus on user experience (UX) and user interface (UI) design principles."
    },
    {
      id: 4,
      question: "Are your websites responsive and mobile-friendly?",
      answer: "Yes, I prioritize responsive design in all my projects to ensure they work well on various devices, including smartphones, tablets, and desktops."
    },
    {
      id: 5,
      question: "How do you approach project collaboration and communication?",
      answer: "I believe in clear and regular communication. I use tools like Slack, Trello, and email for communication and version control systems like Git for collaboration."
    },
    {
      id: 6,
      question: "Can you provide examples of your previous work?",
      answer: "Certainly! You can find examples of my work in the portfolio section of this website. Feel free to explore the projects I've completed."
    },
    {
      id: 7,
      question: "What is your experience with SEO best practices?",
      answer: "I have a good understanding of SEO principles and apply them during website development to ensure better visibility and ranking on search engines."
    },
    {
      id: 8,
      question: "How do you handle website security?",
      answer: "I prioritize website security by implementing best practices such as using HTTPS, input validation, and protecting against common security threats like SQL injection and XSS attacks."
    }
  ];
  
  export default faqData;
  